import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Collapse,
  Alert,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useSaveCovenant } from './hooks/useSaveCovenant';

export default function CovenantFormModal({ open, onClose, onSave, covenant, initialName }) {
  const navigate = useNavigate();
  const { save: saveCovenant } = useSaveCovenant();

  const [formName, setFormName] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (open) {
      setFormName(covenant?.name ?? initialName ?? '');
      setError('');
    }
  }, [open, covenant, initialName]);

  const isValid = formName.trim() !== '';

  const save = () => {
    if (!isValid) return;

    const payload = { name: formName.trim() };

    saveCovenant(covenant ? covenant.id : null, payload)
      .then((returnFromApi) => {
        onSave(payload, returnFromApi.data);
        onClose();
      })
      .catch((returnFromApi) => {
        if (returnFromApi.response?.status === 401) {
          navigate('/expired-session');
        } else {
          setError(returnFromApi.response?.data ?? 'Erro ao salvar convênio.');
        }
      });
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ fontWeight: 'bold' }}>
        {covenant ? 'Editar Convênio' : 'Novo Convênio'}
      </DialogTitle>
      <DialogContent>
        <Collapse in={!!error} sx={{ mb: 1 }}>
          <Alert severity="error" onClose={() => setError('')}>
            {typeof error === 'string' ? error : 'Erro ao salvar convênio.'}
          </Alert>
        </Collapse>
        <TextField
          autoFocus
          label="Nome"
          fullWidth
          value={formName}
          onChange={(e) => setFormName(e.target.value)}
          placeholder="Ex: Unimed"
          inputProps={{ 'data-cy': 'covenant-name' }}
          sx={{ mt: 1 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button variant="contained" onClick={save} disabled={!isValid} data-cy="save-covenant-btn">
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

CovenantFormModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  covenant: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
  }),
  initialName: PropTypes.string,
};

CovenantFormModal.defaultProps = {
  covenant: null,
  initialName: '',
};
